import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core";

import { CUSTOMIZATIONS } from "constants/integration/customizations";
import theme from "../../styles/theme";
import { getImageSource } from "./helpers";
import { BrandRecord } from "records/brand";
import { IStore } from "../../reducers";
import { IProduct } from "records/item/item";

export interface ICustomizationImageViewProps {
    attributeImageUrl: string;
    product: IProduct;
}

export interface ICustomizationImageViewStateProps {
    brand: BrandRecord | null;
}

export const CustomizationImageViewContainer: React.FC<
    ICustomizationImageViewProps & ICustomizationImageViewStateProps
> = ({ brand, attributeImageUrl, product }) => {
    const classes = useStyles();
    const imageSource = getImageSource(brand, product, attributeImageUrl);

    return (
        <div className={classes.previewImage}>
            <img
                data-test={`${CUSTOMIZATIONS.SELECTED_ATTRIBUTE_IMAGE}`}
                src={imageSource}
                role="presentation"
                alt="product customization attribute image"
            />
        </div>
    );
};

const mapStateToProps = (state: IStore): ICustomizationImageViewStateProps => ({
    brand: state?.scope?.brand,
});

export const CustomizationImageView = connect<ICustomizationImageViewStateProps, {}, ICustomizationImageViewProps>(
    mapStateToProps
)(CustomizationImageViewContainer);

const useStyles = makeStyles({
    previewImage: {
        backgroundColor: theme.palette.white,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: "1",
        "& > img": {
            maxWidth: "75%",
            maxHeight: "75%",
        },
    },
});
